/**
 * Update dimensions when variant changes
 */
(function() {
  
  // Listen for variant change
  document.addEventListener('change', function(event) {
    if (event.target.matches('input[name="id"], select[name="id"]')) {
      const variantId = event.target.value;
      updateDimensions(variantId);
    }
  });
  
  async function updateDimensions(variantId) {
    try {
      // Get section ID from the main element
      const mainSection = document.querySelector('[id*="__main"]');
      if (!mainSection) return;
      
      const sectionId = mainSection.id.replace('shopify-section-', '');
      
      // Fetch only the main section with the variant
      const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
      const response = await fetch(url);
      const html = await response.text();
      
      // Parse and extract the dimensions block
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newBlock = doc.querySelector('[data-variant-dimensions-block]');
      
      if (newBlock) {
        const currentBlock = document.querySelector('[data-variant-dimensions-block]');
        if (currentBlock) {
          currentBlock.innerHTML = newBlock.innerHTML;
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
})();



